import styles from './LoadingState.module.css';

export function LoadingState({ label }: { label: string }) {
  return (
    <div className={styles.loading} role="status">
      <div className={styles.title}>
        <span className={styles.spinner} />
        Loading
      </div>
      <p className={styles.label}>{label}</p>
    </div>
  );
}
